import { useSelector } from 'react-redux';
import { firstRoundSyncsComplete } from '../selectors/devices';

const useFirstRoundCompleteUUIDs = () => {
	return useSelector(firstRoundSyncsComplete);
}

export default useFirstRoundCompleteUUIDs;